import { useQuery } from 'react-query';

import { getUniquePestsChart } from 'api/analitics/EncCharts/getUniquePestsChart';

export const useGetUniquePestsChart = (slug: string, start_date: string, end_date: string) => {
  return useQuery(['uniquePestsChart', slug, start_date, end_date], () =>
    getUniquePestsChart(slug, start_date, end_date),
  );
};
